import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductCodeQuery } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-account-nav',
  templateUrl: './account-nav.component.html',
  styleUrls: ['./account-nav.component.scss'],
})
export class AccountNavComponent implements OnInit, OnDestroy {
  partnerDisabled: boolean = false;
  isPartner: boolean = false;

  private _destroyed$ = new Subject<void>();

  @Input() isMarginBottom: boolean = true;
  productCode = ProductCode;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private productCodeQuery: ProductCodeQuery
  ) {}

  ngOnInit() {
    this.checkpartnerDisabledFlag();

    this.isPartner = this.productCodeQuery.currentUserIsProductCode(ProductCode.Partners);
  }

  checkpartnerDisabledFlag() {
    this.translate
      .stream('partner.disabled.flag')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        if (data === 'true') {
          this.partnerDisabled = JSON.parse(data);
        }
      });
  }

  isActive(url: string): boolean {
    // Check if the route contains query params.
    const hasQueryParams = Object.keys(this.route.snapshot.queryParams)?.length > 0;
    return this.router.isActive(url, true) || (this.router.isActive(url, false) && hasQueryParams);
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
